<template src="../templates/searchBookings.html"></template>

<script>
import ContactModel from "../models/contactModel";
import JobsCollection from "../collections/jobsCollection";
import SearchModel from "../models/searchBookingModel";
import XLSX from "xlsx";
import DynamicBookingDetail from "./DynamicBookingDetail";
import SearchBookingFilter from "./SearchBookingFilter";
import MultipleSortBooking from "./MultipleSortBooking";
import BookingsRow from "./BookingsRowComponent";
import BookingsHeaderRow from "./BookingsHeaderRowComponent";
import PrintBookingsComponent from "./PrintBookingsComponent";
import moment from "moment";
import { EventBus } from "../event-bus.js";
import myAlert from "./myAlert";

export default {
  name: "Search",
  components: {
    DynamicBookingDetail,
    BookingsHeaderRow,
    BookingsRow,
    SearchBookingFilter,
    PrintBookingsComponent,
    myAlert,
    MultipleSortBooking
  },
  props: ["jobId"],
  watch: {
    sortList: function(newVal, oldVal) {
      console.log("Parent Updated with new List", newVal);
    },
    jobId: function(newVal, oldVal) {
      console.log("watch jobitd triggered");
      this.searchModel.search = newVal;
      this.clearIntervals();
      this.initialSettings(true);
    },
    isInterval: function() {
      let thisComp = this;
      this.intervalVar.push(
        setInterval(function() {
          // console.log('interval triggered');
          // console.log(thisComp.intervalVar);
          thisComp.updateJobStatus(thisComp.jobsData);
        }, 10000)
      );
    }
  },
  data() {
    return {
      contactModel: new ContactModel(),
      jobsCollection: new JobsCollection(),
      expandRowKeys: [],
      jobsData: [],
      jobsDataArray: [],
      searchModel: new SearchModel(),
      search: "",
      jobsToPrint: [],
      printDialogVisible: false,
      filterDialogVisible: false,
      multipleSortDialog: false,
      sortField: "",
      sortDirection: "",
      total: 0,
      totalRecordsLabel: 0,
      recordFrom: 0,
      recordTo: 0,
      pageSize: 50,
      currentPage: 1,
      dynamicHtml: "",
      statusFilterValue: "",
      currentSort: {
        column: "null",
        order: "null"
      },
      options: [
        {
          value: 0,
          label: "All"
        },
        {
          value: 5,
          label: "5"
        },
        {
          value: 10,
          label: "10"
        },
        {
          value: 15,
          label: "15"
        },
        {
          value: 20,
          label: "20"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 100,
          label: "100"
        }
      ],
      intervalVar: [],
      isInterval: false,
      dismissCountDown: 0,
      tickAll: false,
      alertMessage: "",
      notClockedEarlyText: "No Clocked On/Early Clock Off",
      isEditable: false,
      isDataLoading: true,

      sortList: []
    };
  },
  methods: {
    sortListEvent(arg) {
      this.sortList = arg;
    },

    initialSettings(status = false) {
      console.log("jobId");
      console.log(this.jobId);

      this.isDataLoading = true;
      if (localStorage.getItem("pageSize") != null) {
        this.pageSize = parseInt(localStorage.getItem("pageSize"));
      } else {
        localStorage.setItem("pageSize", "50");
      }
      this.isInterval = true;
      if (this.jobId != null) {
        // this.searchModel.search = this.jobId;
        this.searchModel.refNum = this.jobId;
        this.searchModel.startServiceDate = "";
        this.searchModel.endServiceDate = null;
      }

      this.loadJobs(status);
      this.loadDetails();
    },
    tickAllChanged(tickedAll) {
      this.jobsData.forEach(el => {
        console.log("tickedAll");
        console.log(tickedAll);

        el.selected = tickedAll;
      });
      console.log(this.jobsData);
      this.tickAll = tickedAll;
    },
    onColumnSortChanged(field, direction) {
      this.jobsData = [];
      this.currentSort.column = field;
      this.currentSort.order = direction;
      this.clearIntervals();
      this.loadJobs(true);
    },
    // added by mj for Alert
    onClose() {
      this.dismissCountDown = 0;
    },
    printDialogClose() {
      this.jobsToPrint = [];
    },
    fileDownloaded() {
      this.printDialogVisible = false;
      this.alertMessage = "File downloaded successfully";
      this.dismissCountDown = 5;
    },
    onFilterConfirmed() {
      this.filterDialogVisible = false;
      this.clearIntervals();
      this.loadJobs(false);
    },

    onSortConfirmed() {
      this.multipleSortDialog = false;
      this.clearIntervals();
      this.loadJobs(false);
    },
    loadDetails: function() {
      this.contactModel = new ContactModel();
      let url = this.$localApiURL + this.contactModel.getRoute("fetch");
      let self = this;
      this.contactModel
        .fetch({
          url: url,
          params: { token: localStorage.getItem("jwt") }
        })
        .then(res => {
          if (
            self.contactModel != null &&
            self.contactModel.clientId == "10483"
          ) {
            self.notClockedEarlyText = "No Clocked On";
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    loadJobs: function(clearPager) {
      this.isDataLoading = true;
      console.log("loadJobs RUNNING");

      if (clearPager) {
        this.total = 0;
        this.currentPage = 1;
      }
      this.searchModel
        .validate()
        .then(response => {
          let errorExists = false;
          for (let item in response) {
            if (item != null) {
              errorExists = true;
              break;
            }
          }
          if (!errorExists) {
            this.jobsCollection = new JobsCollection();
            let localThis = this;
            let url = this.$localApiURL + this.jobsCollection.getRoute("fetch");
            let params = this.getPostParams();
            this.$http
              .post(url, params)
              .then(function(response) {
                if (response.data !== null && response.data !== {}) {
                  let result = response.data;
                  localThis.totalRecordsLabel = parseInt(
                    result.total ? result.total : "0"
                  );
                  if (localThis.pageSize === 0) {
                    localThis.total = 0;
                    localThis.recordFrom = 1;
                    localThis.recordTo = localThis.totalRecordsLabel;
                  } else {
                    localThis.total = localThis.totalRecordsLabel;
                  }
                  let pageSizeEnd = localThis.pageSize * localThis.currentPage;
                  localThis.jobsData = result.data;
                  localThis.recordFrom =
                    localThis.totalRecordsLabel === 0
                      ? localThis.totalRecordsLabel
                      : localThis.pageSize * (localThis.currentPage - 1) + 1;
                  localThis.recordTo =
                    pageSizeEnd >= localThis.totalRecordsLabel ||
                    pageSizeEnd === 0
                      ? localThis.totalRecordsLabel
                      : pageSizeEnd;
                  localThis.updateJobStatus(localThis.jobsData);
                } else {
                  localThis.total = 0;
                  localThis.jobsData = [];
                }

                localThis.isDataLoading = false;
              })
              .catch(function(error) {
                localThis.isDataLoading = false;
                console.log(error);
              });
          }
        })
        .catch(function(error) {
          console.error(error);
        });
    },
    getPostParams(isExport = false) {
      console.log("getPostParams run", this.sortList);
      let startServiceDate = this.searchModel.startServiceDate;
      let endServiceDate = this.searchModel.endServiceDate;
      let pageSize = isExport ? 0 : this.pageSize;
      return {
        startServiceDate:
          startServiceDate !== null && startServiceDate !== ""
            ? moment(this.searchModel.startServiceDate).format("YYYYMMDD")
            : "null",
        endServiceDate:
          endServiceDate !== null && endServiceDate !== ""
            ? moment(this.searchModel.endServiceDate).format("YYYYMMDD")
            : "null",
        status:
          this.searchModel.statusFilterValue !== null &&
          this.searchModel.statusFilterValue !== ""
            ? this.searchModel.statusFilterValue
            : "null",
        search:
          this.searchModel.search !== null && this.searchModel.search !== ""
            ? this.searchModel.search
            : "null",
        searchFilter: this.searchModel.attributes,
        currentPage: this.currentPage,
        pageSize: pageSize,
        sortColumn: this.currentSort.column,
        sortOrder: this.currentSort.order,
        token: localStorage.getItem("jwt"),
        multipleSortOrder: this.sortList
      };
    },
    handleSizeChange(val) {
      localStorage.setItem("pageSize", val);
      this.clearIntervals();
      this.loadJobs(true);
      // console.log(`${val} items per page`);
    },
    current_change: function(currentPage) {
      this.currentPage = currentPage;
      this.clearIntervals();
      this.loadJobs(false);
    },
    onSortChange: function(event) {
      this.jobsData = [];
      this.currentSort.column = event.prop;
      this.currentSort.order = event.order;
      this.clearIntervals();
      this.loadJobs(true);
    },
    handleExpandChange(row, expandedRows) {
      const id = row.id;
      const lastId = this.expandRowKeys[0];
      // disable mutiple row expanded
      this.expandRowKeys = id === lastId ? [] : [id];
    },
    printData: function() {
      this.jobsToPrint = this.jobsData.filter(x => x.selected === true);
      if (this.jobsToPrint !== null && this.jobsToPrint.length > 0) {
        this.printDialogVisible = true;
      } else {
        this.alertMessage = "Select record's to print!";
        this.dismissCountDown = 5;
      }
    },
    exportData: function() {
      let url = this.$localApiURL + this.jobsCollection.getRoute("fetch");
      let params = this.getPostParams(true);
      let self = this;
      this.$http
        .post(url, params)
        .then(function(response) {
          let result = response.data;
          let data = result.data;

          if (data !== null && data.length > 0) {
            let momentDate = moment(new Date()).format("YYYYMMDDHHmmss");
            let fileName = "export_" + momentDate.toString() + ".xlsx";
            let exportData = [];
            let index;
            for (index in data) {
              let attributes = data[index];

              attributes.bookingStatus = "Assigned";
              if (attributes.Cancellation === "1") {
                attributes.bookingStatus = "Cancelled";
              } else if (attributes.int_id === "001") {
                attributes.bookingStatus = "Waiting to Assign Interpreter";
              } else if (
                attributes.int_id === "" ||
                attributes.int_id === "004" ||
                attributes.int_id === "005"
              ) {
                attributes.bookingStatus = "Waiting to Assign Interpreter";
              } else if (attributes.not_serviced === "1") {
                attributes.bookingStatus = "Not Serviced";
              }
              self.processJobTypeRules(attributes);
              self.removeUnnecessaryFields(attributes);

              exportData.push(attributes);
            }
            let worksheet = XLSX.utils.json_to_sheet(exportData, {
              header: [
                "ref_num",
                "serviceDate",
                "serviceTimeStart",
                "serviceTimeEnd",
                "language",
                "location_address_1",
                "location_address_2",
                "location_name",
                "suburb",
                "interpreter_name",
                "CALD",
                "job_type",
                "cpnNumber",
                "certification",
                "naati_number",
                "accreditation",
                "bookingStatus"
              ]
            });
            let wb = XLSX.utils.book_new(); // make Workbook of Excel
            XLSX.utils.book_append_sheet(wb, worksheet, "data");
            XLSX.writeFile(wb, fileName);
          } else {
            alert("No data to export");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    removeUnnecessaryFields(attributes) {
      delete attributes.id;
      delete attributes.int_id;
      delete attributes.not_serviced;
      delete attributes.activityStatus;
      delete attributes.is_clocked_on;
      delete attributes.is_clocked_off;
      delete attributes.early_clock_off;
      delete attributes.is_not_started;
      delete attributes.is_late_clocked_on;
      delete attributes.is_late_sms_sent;
      delete attributes.Cancellation;
      delete attributes.requested_by;
      delete attributes.jobTypeClass;
      delete attributes.jobTypeText;
      delete attributes.statusClass;
      delete attributes.nesbs;
      delete attributes.interpreter_id;
      delete attributes.jobSessionId;
      delete attributes.selected;
      delete attributes.service_date_safari;
      delete attributes.start_safari;
      delete attributes.end_safari;
      delete attributes.cpnNumberLabel;
      delete attributes.location;
    },
    updateJobStatus(jobList) {
      jobList.forEach(this.processJobRules);
    },
    processJobRules(job) {
      if (job == null) {
        return;
      }
      this.processJobTypeRules(job);
      this.processJobStatusRules(job);
      this.processActivityStatusRules(job);
    },
    processJobStatusRules(job) {
      job.statusClass = "far fa-smile";
      job.statusStyle = "color: #30bd1a";
      if (job.Cancellation === "1") {
        job.statusClass = "fas fa-times";
        job.statusStyle = "color: #db4725";
      } else if (job.int_id === "001") {
        job.statusClass = "fas fa-frown";
        job.statusStyle = "color: #db4725";
      } else if (
        job.int_id === "" ||
        job.int_id === "004" ||
        job.int_id === "005"
      ) {
        job.statusClass = "far fa-hourglass";
        job.statusStyle = "color: #d1b33d";
      } else if (job.not_serviced === "1") {
        job.statusClass = "fas fa-tools";
        job.statusStyle = "";
      }
    },
    processJobTypeRules(job) {
      switch (job.job_type.toLowerCase()) {
        case "ph int":
          job.jobTypeClass = "fas fa-phone";
          job.jobTypeText = "Telephone interpreting";
          break;
        case "trans":
          job.jobTypeClass = "fas fa-language";
          job.jobTypeText = "Translation";
          break;
        case "video":
          job.jobTypeClass = "fas fa-video";
          job.jobTypeText = "Video Interpreting";
          break;
        case "inter":
          job.jobTypeClass = "fas fa-user-friends";
          job.jobTypeText = "Interpreting";
          break;
        default:
          job.jobTypeClass = "fas fa-question";
          job.jobTypeText = "Unknown job type";
          break;
      }
    },
    processActivityStatusRules(job) {
      let currentDate = new Date();
      let strDateStart = job.service_date_safari + " " + job.start_safari;
      let strDateEnd = job.service_date_safari + " " + job.end_safari;

      let dateTimeStart = (Date.parse(strDateStart) / 1000).toFixed();
      let dateTimeEnd = (Date.parse(strDateEnd) / 1000).toFixed();

      const dateObjN = new Date();
      let dateNow = (dateObjN / 1000).toFixed();

      const dateObjP = new Date(strDateStart);
      const minus30FromServiceStartTime = dateObjP.setMinutes(
        dateObjP.getMinutes() - 30
      );
      const minus30Date = new Date(minus30FromServiceStartTime);

      let calculateMinusDateTime = (minus30Date / 1000).toFixed();

      if (job.is_clocked_off === "1") {
        job.activityStatus = "circleGreenOk clockOff"; // clock off
      } else if (job.service_date < currentDate) {
        job.activityStatus = "circleRed"; // old service date.
      } else if (job.is_clocked_on === "0") {
        /** Condition 1: Job start not in the future or Job end is not in the past **/
        if (dateNow > dateTimeStart && dateNow < dateTimeEnd) {
          /** Job is within Start and End Time **/
          // console.log('Job is within Start and End Time');
          job.activityStatus = "circleRed";
        } else if (
          dateNow <= dateTimeStart &&
          calculateMinusDateTime <= dateNow
        ) {
          /** Job is within 30 minutes of start **/
          // console.log('Job is within 30 minutes of start');
          job.activityStatus = "within30Minutes";
        } else {
          /** Job is not within Start and End Time **/
          // console.log('Job is not within Start and End Time');
          job.activityStatus = "notWithinTimeRange";
        }

        if (job.is_late_sms_sent === "1") {
          job.activityStatus = "circleOrange"; // late sms
        } else if (
          job.is_not_started === "1" ||
          job.is_late_clocked_on === "1"
        ) {
          job.activityStatus = "circleAmber"; // not started or late clock on
        }
      } else {
        job.activityStatus = "circleGreen"; // clocked on
      }
    },
    clearIntervals() {
      for (let intervalID of this.intervalVar) {
        clearInterval(intervalID);
      }

      this.intervalVar = [];
      this.isInterval = !this.isInterval;
    },
    keepInputFocused() {
      this.$nextTick(() => this.$refs.serviceEndDate.focus());
    }
  },
  created() {
    this.initialSettings();
  },
  mounted() {
    this.sockets.subscribe("activity-status-message", wsMessage => {
      EventBus.$emit(
        "activity-bus-message",
        wsMessage.category,
        wsMessage.data[0]
      );
    });

    let self = this;
    window.addEventListener("keyup", function(keyBoard) {
      if (keyBoard.keyCode === 13) {
        self.initialSettings(); // declared in your component methods
      }
    });
  },
  unmounted() {
    this.sockets.unsubscribe("activity-status-message");
  },
  destroyed() {
    this.sockets.unsubscribe("activity-status-message");
  },
  beforeDestroy() {
    this.clearIntervals();
  }
};
</script>

<style lang="scss">
@import "../assets/scss/general.scss";

.scrollable {
  $filterOption: 63px;
  $tableHeader-margin: 25px;
  $tableHeader: 58px;
  $pagination: 50px;
  $pagination: 50px;

  /*
      Use Interpolation
      #{$bodyTopMargin}
  */
  $total: calc(
    #{$navHeader} + #{$bodyTopMargin} + #{$filterOption} + #{$tableHeader-margin} +
      #{$tableHeader} + #{$pagination} + #{$footer}
  );

  height: calc(100vh - #{$total});
  overflow-y: scroll;
  background: #fff;
}

.myPagination-group {
  > div {
    padding: 1px 5px;
    color: $myColor-gray-text;

    b {
      color: $myColor-primary;
    }
  }

  .el-input__inner {
    height: 35px !important;
  }

  .myPagination {
    /* Font*/
    li {
      padding-top: 3px;
      font-size: 16px;
      font-weight: normal;
    }

    /* Element Size and the Border */
    li,
    button {
      margin: 0 !important;
      border: 1px solid $myColor-blue-header;
      border-radius: 0 !important;
      width: 45px !important;
      height: 35px !important;
      align-items: center;

      &:not(:disabled):hover {
        background: rgba($myColor-primary, 0.8) !important;
        color: #fff !important;
      }

      &:not(:disabled).active {
        background: $myColor-primary !important;
        color: #fff;
        border-bottom: 3px solid $myColor-secondary;
      }
    }
  }
}

// *** PAGINATION
</style>



// WEBPACK FOOTER //
// src/components/SearchBookingsComponent.vue